import { closest, dispatchEvent } from '@nrk/dh-basis-common'

export function setupKeyboardNavigator(app) {
  const keydown = (e) => {
    const anchor = closest(e.target, 'a, button, input')
    if (anchor) {
      return
    }
    if (e.keyCode === 38 && !e.metaKey) {
      // Up
      e.preventDefault()
      e.stopPropagation()
      app.navigateUp()
      dispatchEvent(app, 'dh-kortstokk-keyboard-navigation')
    } else if (e.keyCode === 40 && !e.metaKey) {
      // Down
      e.preventDefault()
      e.stopPropagation()
      app._navigateDown()
      dispatchEvent(app, 'dh-kortstokk-keyboard-navigation')
    } else if (e.keyCode === 32) {
      // Down
      e.preventDefault()
      e.stopPropagation()
      if (e.shiftKey) {
        app.navigateUp()
      } else {
        app.navigateDown()
      }
      dispatchEvent(app, 'dh-kortstokk-keyboard-navigation')
    }
  }

  document.addEventListener('keydown', keydown)
  return () => {
    document.removeEventListener('keydown', keydown)
  }
}
